module.exports = __webpack_public_path__ + "assets/470e141d70a11682cece30a011452ad5.png";